import {
  ADD_ACCESS_FAILURE,
  ADD_ACCESS_LOADING,
  ADD_ACCESS_SUCCESS,
  DELETE_ACCESS_FAILURE,
  DELETE_ACCESS_LOADING,
  DELETE_ACCESS_SUCCESS,
  FETCH_ACCESS_FAILURE,
  FETCH_ACCESS_LOADING,
  FETCH_ACCESS_SUCCESS,
  UPDATE_ACCESS_FAILURE,
  UPDATE_ACCESS_LOADING,
  UPDATE_ACCESS_SUCCESS,
  UPDATE_GROUP_ACCESS_FAILURE,
  UPDATE_GROUP_ACCESS_LOADING,
  UPDATE_GROUP_ACCESS_SUCCESS,
  FETCH_GROUP_ACCESS_LOADING,
  FETCH_GROUP_ACCESS_SUCCESS,
  FETCH_GROUP_ACCESS_FAILURE,
  FETCH_ZONE_PRIORITIES_WITH_USERS_LOADING,
  FETCH_ZONE_PRIORITIES_WITH_USERS_SUCCESS,
  FETCH_ZONE_PRIORITIES_WITH_USERS_FAILURE,
  DELETE_INDIVIDUAL_ACCESS_LOADING,
  DELETE_INDIVIDUAL_ACCESS_SUCCESS,
  DELETE_INDIVIDUAL_ACCESS_FAILURE
} from '../Types/accessTypes';

const initState = {
  data: [],
  error: null,
  success: null,
  loading: true,
  item: {},
  groupAccessData: [],
  zonePrioritiesWithUsers: []
};

const accessReducer = function (state = initState, action) {
  switch (action.type) {
    case FETCH_ACCESS_LOADING:
    case ADD_ACCESS_LOADING:
    case FETCH_ZONE_PRIORITIES_WITH_USERS_LOADING:
    case UPDATE_ACCESS_LOADING:
    case DELETE_INDIVIDUAL_ACCESS_LOADING:
    case FETCH_GROUP_ACCESS_LOADING:
    case UPDATE_GROUP_ACCESS_LOADING:
    case DELETE_ACCESS_LOADING:
      return {
        ...state,
        loading: true
      };

    case FETCH_ACCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: null,
        data: action.payload
      };
    case ADD_ACCESS_SUCCESS:
      return {
        ...state,
        data: [...state.data, action.payload],
        loading: false,
        error: null,
        success: 'Access added successfully'
      };
    case FETCH_GROUP_ACCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        groupAccessData: action.payload
      };

    case DELETE_INDIVIDUAL_ACCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: 'Individual access deleted successfully',
        data: state.data.filter(item => item._id !== action.payload)
      };

    case FETCH_ZONE_PRIORITIES_WITH_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        zonePrioritiesWithUsers: action.payload
      };

    case UPDATE_ACCESS_SUCCESS:
    case UPDATE_GROUP_ACCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data.map(item => (item._id === action.payload._id ? action.payload : item)),
        error: null,
        success: 'Access updated successfully'
      };

    case DELETE_ACCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: 'Access removed successfully',
        data:
          action.payload?.length > 0
            ? state.data.filter(item => !action.payload.includes(item._id))
            : state.data.filter(item => item._id !== action.payload)
      };

    case FETCH_ACCESS_FAILURE:
    case ADD_ACCESS_FAILURE:
    case UPDATE_ACCESS_FAILURE:
    case FETCH_GROUP_ACCESS_FAILURE:
    case UPDATE_GROUP_ACCESS_FAILURE:
    case DELETE_INDIVIDUAL_ACCESS_FAILURE:
    case FETCH_ZONE_PRIORITIES_WITH_USERS_FAILURE:
    case DELETE_ACCESS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return { ...state };
  }
};

export default accessReducer;
